const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotarinIconUnternehmen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-671.875,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,671.875,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arbeit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.965,460.859L170.965,508.859L105.187,508.859L105.187,460.859L0,460.859L0,258.192L274.374,258.192L274.374,460.859L170.965,460.859ZM170.965,443.955C170.965,443.955 257.471,443.955 257.471,443.955L257.471,275.096L16.904,275.096L16.904,443.955L105.187,443.955C114.523,443.955 122.091,451.523 122.091,460.859C122.091,460.859 122.091,491.955 122.091,491.955L154.061,491.955L154.061,460.859C154.061,451.523 161.629,443.955 170.965,443.955Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.27586,0,0,1,-48.6777,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.152,359.525L172.152,508.859L120.597,508.859L120.597,359.525L172.152,359.525ZM158.903,376.429L133.846,376.429C133.846,376.429 133.846,491.955 133.846,491.955L158.903,491.955L158.903,376.429Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.52381,0,-261.762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.819,494.637L214.819,531.97L67.263,531.97L67.263,494.637L214.819,494.637ZM197.915,505.73L84.167,505.73L84.167,520.877L197.915,520.877L197.915,505.73Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.78277,-3.37508e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.187,0C164.778,0 213.157,48.38 213.157,107.97C213.157,167.56 164.778,215.94 105.187,215.94C45.597,215.94 -2.783,167.56 -2.783,107.97C-2.783,48.38 45.597,0 105.187,0ZM105.187,16.904C54.926,16.904 14.121,57.709 14.121,107.97C14.121,158.231 54.926,199.036 105.187,199.036C155.448,199.036 196.253,158.231 196.253,107.97C196.253,57.709 155.448,16.904 105.187,16.904Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.97,50.278L107.97,107.97L149.93,107.97",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.374,376.414L341.041,359.525L375.708,441.303L419.263,359.525L490.374,378.192L508.152,394.192",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.486,531.97L241.486,460.859",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.93301,0,0,1.21505,-43.0749,-51.2705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.819,176.414C499.793,176.414 537.93,214.551 537.93,261.526C537.93,308.5 499.793,346.637 452.819,346.637C405.845,346.637 367.708,308.5 367.708,261.526C367.708,214.551 405.845,176.414 452.819,176.414ZM452.819,190.327C414.368,190.327 385.825,223.074 385.825,261.526C385.825,299.977 414.368,332.725 452.819,332.725C491.27,332.725 519.812,299.977 519.812,261.526C519.812,223.074 491.27,190.327 452.819,190.327Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.374,258.192C349.995,261.878 380.088,254.507 401.486,229.748L446.819,258.192",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0257,0,0,1.01835,-15.4203,-15.8096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600,400.414L600,551.47L433.986,551.47L433.986,400.414L600,400.414ZM583.52,417.014L450.466,417.014C450.466,417.014 450.466,534.871 450.466,534.871L583.52,534.871L583.52,417.014Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.819,449.103L585.708,449.103",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.708,493.903L446.819,493.903",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.618664,-9.32414e-17,1.55691e-16,1,3.80976,-3.9498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.081,111.92L38.634,111.92",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "20.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-5.72459e-17,-0.618664,1,-9.54098e-17,-3.9498,212.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.081,111.92L38.634,111.92",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "20.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.618664,1.93637e-17,-3.41775e-17,-1,212.13,219.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.081,111.92L38.634,111.92",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "20.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.85186e-17,0.618664,-1,-2.70549e-17,219.89,3.80976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.081,111.92L38.634,111.92",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "20.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00559,0,0,1.05152,-14.008,-30.9137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.597,535.303L610.597,600L13.93,600L13.93,535.303L610.597,535.303ZM593.787,551.379C593.787,551.379 125.999,551.379 30.74,551.379L30.74,583.924C116.835,583.924 507.691,583.924 593.787,583.924L593.787,551.379Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarinIconUnternehmen);
export default __webpack_public_path__ + "static/media/Notarin_Icon_Unternehmen.4646e19e096b7f0d4af08519860ba216.svg";
export { ForwardRef as ReactComponent };